var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42188 7.43387L13.1419 0.713867L15.4276 2.99958",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5703 3.28516L12.5703 5.28516",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99888 13.2849C4.44913 13.2849 4.89497 13.1962 5.31094 13.0239C5.72692 12.8516 6.10488 12.599 6.42325 12.2807C6.74162 11.9623 6.99417 11.5843 7.16647 11.1684C7.33877 10.7524 7.42746 10.3066 7.42746 9.85631C7.42746 9.40606 7.33877 8.96022 7.16647 8.54425C6.99417 8.12827 6.74162 7.75031 6.42325 7.43194C6.10488 7.11357 5.72692 6.86102 5.31094 6.68872C4.89497 6.51642 4.44913 6.42773 3.99888 6.42773C3.08957 6.42773 2.2175 6.78896 1.57452 7.43194C0.931536 8.07492 0.570313 8.94699 0.570312 9.85631C0.570313 10.7656 0.931536 11.6377 1.57452 12.2807C2.2175 12.9237 3.08957 13.2849 3.99888 13.2849Z",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password-icon.4845db9fae779369375434feb5c901c3.svg";
export { ForwardRef as ReactComponent };